<!--
 * @Author: your name
 * @Date: 2020-02-27 15:01:53
 * @LastEditTime: 2020-12-22 14:47:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /gofun-conn-h5-protal/src/App.vue
 -->

<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created(){
    this.$store.dispatch("getUseHelpPage")
  },
  mounted() {
    window.addEventListener("hashchange", () => {
      let current = window.location.hash.slice(1);
      this.$router.push(current);
    });
  }
};
</script>
<style>

@font-face {
  font-family: 'FZLTH';
  src: url('/src/assets/fonts/FZLTH.TTF');
}
@font-face {
  font-family: 'FZLTCH';
  src: url('/src/assets/fonts/FZLTCH.TTF');
}
html {
  font-family: 'PingFangSC-Regular', 'FZLTH';
}
/* ::-webkit-scrollbar {
    width: 2px;
}
::-webkit-scrollbar-thumb {
    border-radius: 2px;
    -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
}
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
} */
</style>

<style lang="scss">
html,
body {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  font-size: 13px;
}
#app {
  height: 100%;
  width: 100%;
  // font-family: Avenir, Helvetica, SimSun, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  overflow-y: auto;
}
.el-table::before{
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue